// extracted by mini-css-extract-plugin
export var desktop_only = "ResolutionContent-module--desktop_only--8e84f";
export var mobile_only = "ResolutionContent-module--mobile_only--60ef7";